import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IEditNotableEventIncidentRequestModel from "interfaces/Request/IEditNotableEventIncidentRequestModel";
import ISiteDiaryEventIncidentViewModel from "interfaces/SiteDiary/EventIncident/ISiteDiaryEventIncidentViewModel";
import { PencilSquare } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const EditTemplate = (props: ISiteDiaryEventIncidentViewModel): any => {
  const {
    id, hwrcSiteId, diaryDate, details, timeRecorded
  } = props;
  // eslint-disable-next-line max-len
  const editUrl = encodeURI(`${RoutePathsEnum.SiteDiaryEditEventsAndIncidents}/${hwrcSiteId}/${diaryDate}/${id}`);

  const editData : IEditNotableEventIncidentRequestModel = {
    timestamp: timeRecorded.toISOString(),
    notes: details
  };

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };

  return (
    <>
      <Link data-testid="eventIncidentEditButton" state={editData} to={editUrl} onContextMenu={handleContextMenu}>
        <PencilSquare color="#000" />
        <span className="visually-hidden">
          edit
          {id}
        </span>
      </Link>
    </>
  );
};
export default EditTemplate;
